/* istanbul ignore file */
export enum SidesheetSize {
    Auto = 'auto',      // TODO content sets the width (today's behavior); removed by #13067 is completed
    Small = 'small',    // 608px / 38rem
    Medium = 'medium',  // 1,024px / 64rem
    Large = 'large'     // 1,248px / 78rem
}
